module.exports = function() {
  return new Worker(__webpack_public_path__ + "b2f87f214e3891fcb0ac.worker.js");
};